import Swiper from 'swiper';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="cards"]');

class Cards {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperComponent = component.querySelector('.swiper');
            if (swiperComponent && swiperComponent.querySelectorAll('.swiper-slide').length > 2) this.initSwiper(swiperComponent);
        });
    }

    initSwiper(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Pagination, Navigation],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 24,
            breakpoints: {
                1024: {
                    slidesPerView: 2,
                }
            },
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: swiperComponent.querySelector('.swiper-pagination'),
                clickable: true,
                type: 'bullets',
            },
            on: {
                init: (swiper) => {

                },
                afterInit: (swiper) => {
                    if (swiper.slides.length > 2) {
                        swiper.el.querySelector('.swiper-wrapper').classList.remove('flex', 'flex-col', 'md:flex-row', 'gap-4', 'md:gap-14');
                        swiper.el.querySelector('.pagination').classList.add('active');

                        swiper.el.querySelectorAll('.swiper-slide').forEach(el => {
                            el.classList.remove('flex-1')
                        });
                    }
                }
            },
        });
    }
}

(() => {
    if (MODULE) {
        new Cards();
    }
})();

export default Cards;
